import React from 'react';
import { Download, Share, Plus, Smartphone, MoreVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function InstallPromptContent({ platform, onInstall, onDismiss }) {
  // iOS Safari: manual instructions
  if (platform === 'ios') {
    return (
      <div className="flex flex-col items-center gap-4 p-6 pb-8">
        <div className="w-14 h-14 rounded-2xl bg-[#6E2BFF]/20 flex items-center justify-center">
          <Smartphone className="w-7 h-7 text-[#6E2BFF]" />
        </div>

        <div className="text-center">
          <h3 className="text-lg font-semibold text-white">Ajouter ZNO</h3>
          <p className="text-sm text-[#9CA0AB] mt-1">
            Installe ZNO sur ton ecran d'accueil en 2 etapes :
          </p>
        </div>

        <div className="flex items-center gap-3 w-full bg-[#13151D] rounded-xl p-3">
          <div className="w-8 h-8 rounded-full bg-[#6E2BFF]/20 flex items-center justify-center text-sm font-bold text-[#6E2BFF] flex-shrink-0">
            1
          </div>
          <p className="text-sm text-white">
            Appuie sur{' '}
            <Share className="inline w-4 h-4 text-[#6E2BFF] mx-0.5" />{' '}
            en bas de Safari
          </p>
        </div>

        <div className="flex items-center gap-3 w-full bg-[#13151D] rounded-xl p-3">
          <div className="w-8 h-8 rounded-full bg-[#6E2BFF]/20 flex items-center justify-center text-sm font-bold text-[#6E2BFF] flex-shrink-0">
            2
          </div>
          <p className="text-sm text-white">
            Choisis{' '}
            <Plus className="inline w-4 h-4 text-[#6E2BFF] mx-0.5" />{' '}
            <strong>Sur l'ecran d'accueil</strong>
          </p>
        </div>

        <Button
          onClick={onDismiss}
          className="w-full bg-[#6E2BFF] hover:bg-[#5A22DD] text-white rounded-xl h-12 text-base font-medium mt-2"
        >
          Compris !
        </Button>
      </div>
    );
  }

  // Android Chrome fallback: manual instructions when beforeinstallprompt didn't fire
  if (platform === 'android-manual') {
    return (
      <div className="flex flex-col items-center gap-4 p-6 pb-8">
        <div className="w-14 h-14 rounded-2xl bg-[#6E2BFF]/20 flex items-center justify-center">
          <Smartphone className="w-7 h-7 text-[#6E2BFF]" />
        </div>

        <div className="text-center">
          <h3 className="text-lg font-semibold text-white">Installer ZNO</h3>
          <p className="text-sm text-[#9CA0AB] mt-1">
            Ajoute ZNO a ton ecran d'accueil en 2 etapes :
          </p>
        </div>

        <div className="flex items-center gap-3 w-full bg-[#13151D] rounded-xl p-3">
          <div className="w-8 h-8 rounded-full bg-[#6E2BFF]/20 flex items-center justify-center text-sm font-bold text-[#6E2BFF] flex-shrink-0">
            1
          </div>
          <p className="text-sm text-white">
            Appuie sur{' '}
            <MoreVertical className="inline w-4 h-4 text-[#6E2BFF] mx-0.5" />{' '}
            en haut de Chrome
          </p>
        </div>

        <div className="flex items-center gap-3 w-full bg-[#13151D] rounded-xl p-3">
          <div className="w-8 h-8 rounded-full bg-[#6E2BFF]/20 flex items-center justify-center text-sm font-bold text-[#6E2BFF] flex-shrink-0">
            2
          </div>
          <p className="text-sm text-white">
            Choisis{' '}
            <Download className="inline w-4 h-4 text-[#6E2BFF] mx-0.5" />{' '}
            <strong>Ajouter a l'ecran d'accueil</strong>
          </p>
        </div>

        <Button
          onClick={onDismiss}
          className="w-full bg-[#6E2BFF] hover:bg-[#5A22DD] text-white rounded-xl h-12 text-base font-medium mt-2"
        >
          Compris !
        </Button>
      </div>
    );
  }

  // Android / Desktop with native install prompt
  return (
    <div className="flex flex-col items-center gap-4 p-6 pb-8">
      <div className="w-14 h-14 rounded-2xl bg-[#6E2BFF]/20 flex items-center justify-center">
        <Download className="w-7 h-7 text-[#6E2BFF]" />
      </div>

      <div className="text-center">
        <h3 className="text-lg font-semibold text-white">Installer ZNO</h3>
        <p className="text-sm text-[#9CA0AB] mt-1">
          Accede a ZNO directement depuis ton ecran d'accueil.
        </p>
      </div>

      <Button
        onClick={onInstall}
        className="w-full bg-[#6E2BFF] hover:bg-[#5A22DD] text-white rounded-xl h-12 text-base font-medium"
      >
        <Download className="w-5 h-5 mr-2" />
        Installer
      </Button>

      <button
        onClick={onDismiss}
        className="text-sm text-[#9CA0AB] hover:text-white transition-colors"
      >
        Plus tard
      </button>
    </div>
  );
}
